import api from '../../api/apiUmkd'
import actions from './umkdActions'

// Получение направлений подготовки
export const getDirectionTraining = () => async (dispatch: any) => {
    const responce = await api.getDirectionTraining()

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setDirectionTraining(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение специализаций
export const getSpecialization = (directionTrainingID: number) => async (dispatch: any) => {
    const responce = await api.getSpecialization(directionTrainingID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSpecialization(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение дисциплин
export const getSubjects = (specializationID: number) => async (dispatch: any) => {
    const responce = await api.getSubjects(specializationID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSubjects(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение файлов
export const getFiles = (subjectID: number) => async (dispatch: any) => {
    const responce = await api.getFiles(subjectID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setFiles(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}


// Удаление файлов
export const deleteFile = (fileID: number, subjectID: number) => async (dispatch: any) => {
    const responce = await api.deleteFile(fileID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(subjectID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Перемещение файла в другой раздел
export const movedFile = (fileID: number, fileMoveType: string, subjectID: number) => async (dispatch: any) => {
    const responce = await api.movedFile(fileID, fileMoveType)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(subjectID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Загрузка файлов УМКД
export const uploadUmkd = (file: any, subjectID: number, fileType: string, fileName: string) => async (dispatch: any) => {
    const responce = await api.uploadUmkd(file, subjectID, fileType, fileName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(subjectID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}




// Очистка направлений подготовки
export const clearDirectionTraining = () => (dispatch: any) => {
    dispatch(actions.setDirectionTraining([]))
}

// Очистка специализаций
export const clearSpecialization = () => (dispatch: any) => {
    dispatch(actions.setSpecialization([]))
}

// Очистка дисциплин
export const clearSubjects = () => (dispatch: any) => {
    dispatch(actions.setSubjects([]))
}

// Очистка файлов
export const clearFiles = () => (dispatch: any) => {
    dispatch(actions.setFiles([]))
}